import {
  Grid,
  Avatar,
  Typography,
  Button,
  CardMedia,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { adminProfile } from "../../static-models/AdminProfile";
import { useAppSelector } from "../../redux/hooks";
import { useEffect, useState } from "react";
import SuntecNewLogo from "../../assets/SuntecNewLogo.png";
import Select from "@mui/material/Select";
import { FormControl } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch } from "react-redux";
import { merchantActions } from "../../redux/slices/merchantSlice";
import { constant } from "../../constants";
import DefaultImage from "../../assets/SuntecNewLogo.png";
import dayjs from "dayjs";
import { adminActions } from "../../redux/slices/adminSlice";
import { financeActions } from "../../redux/slices/financeSlice";
import { loginCognitoActions } from "../../redux/slices/loginSlice";
import { loyaltyPointsActions } from "../../redux/slices/LoyaltyPointsSlice";
import { memberActions } from "../../redux/slices/memberSlice";
import { receiptsActions } from "../../redux/slices/recieptsSlice";
import { roleActions } from "../../redux/slices/roleSlice";
import { salesActions } from "../../redux/slices/SalesSlice";
import { shopUserActions } from "../../redux/slices/shopUserSlice";
import { stopSession } from "../../services/interceptors/ApiInterceptor";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  showProfileTrue?: Function;
}
const Header = (props: HeaderProps) => {
  const { showProfileTrue } = props;
  const sendProfileStatus = () => {
    showProfileTrue && showProfileTrue(true);
  };
  const theme = useTheme();
  const [isMerchantRole, setIsMerchantRole] = useState(false);
  const [merchant_logo, setMechantLogo] = useState("");
  const [merchantId, setMechantId] = useState("");
  const firstName = useAppSelector(
    (state: any) => state.persistReducers.login.firstName
  );
  const lastName = useAppSelector(
    (state: any) => state.persistReducers.login.lastName
  );
  const groups = localStorage.getItem("groups");
  const loginName = localStorage.getItem("loginName");
  const merchantLogo = localStorage.getItem("merchant_logo");
  const userRoleGroup = groups ? JSON.parse(groups) : [];
  const navigate = useNavigate();
  const [remainingTime, setRemainingTime] = useState<number | null>(null);
  const resetPersistStates = () => {
    dispatch(adminActions.resetAdminState());
    dispatch(financeActions.resetFinanceReset());
    dispatch(loginCognitoActions.resetLoginState());
    dispatch(loyaltyPointsActions.resetLoyaltyState());
    dispatch(memberActions.resetMemberSlice());
    dispatch(merchantActions.resetMerchantSlice());
    dispatch(receiptsActions.resetReceiptsState());
    dispatch(roleActions.resetRoleSlice());
    dispatch(salesActions.resetSalesSlice());
    dispatch(shopUserActions.resetShopUserSlice());
  };
  const handleLogout = async () => {
    resetPersistStates();
    setTimeout(() => {
      sessionStorage.clear();
      stopSession();
      localStorage.clear();
      navigate("/login");
    }, 1000);
  };
  useEffect(() => {
    const expiresIn = localStorage.getItem("expiresIn");
    const sessionStartTime = localStorage.getItem("sessionStartTime");

    if (expiresIn && sessionStartTime) {
      const sessionEnd = dayjs(sessionStartTime).add(
        parseInt(expiresIn),
        "second"
      );
      const updateRemainingTime = () => {
        const now = dayjs();
        const diff = sessionEnd.diff(now, "second");
        setRemainingTime(diff > 0 ? diff : 0);
      };

      updateRemainingTime();
      const intervalId = setInterval(updateRemainingTime, 1000);

      return () => clearInterval(intervalId);
    }
  }, []);

  useEffect(() => {
    if (userRoleGroup.find((role: any) => role.includes("merchant"))) {
      setIsMerchantRole(true);
    }
  }, []);
  const { loginMerchantsList, selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers?.getMerchantList
  );

  useEffect(() => {
    if (constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN) {
      const { merchant_logo, merchantId } = selectedMerchatDetails;
      setMechantId(merchantId);
      setMechantLogo(merchant_logo);
    }
  }, [selectedMerchatDetails]);

  const [selectedMerchantName, setSelectedMerchantName] = useState(
    isMerchantRole ? merchantId : `${firstName} ${lastName}`
  );

  const [merchantsList, setMerchantsList] = useState<any>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    getMerchantsList();
  }, []);

  useEffect(() => {
    if (remainingTime === 0) {
      handleLogout();
    }
  }, [remainingTime]);

  const getMerchantsList = () => {
    let merchantsArr: any = [];
    loginMerchantsList?.map((item: any, index: number) => {
      if (item.response?.stores?.store[0]) {
        const merchantLogoField =
          item.response?.stores?.store[0].custom_fields.field.find(
            (field: any) => {
              return field.name === "merchant_logo";
            }
          );
        merchantsArr.push({
          merchantName: item.response?.stores?.store[0].name,
          value: item.response?.stores?.store[0].id.toString(),
          merchant_logo: merchantLogoField?.value,
        });
      }
    });
    setSelectedMerchantName(selectedMerchatDetails?.merchantId);
    setMerchantsList(merchantsArr);
  };

  const handleClick: any = async (event: any) => {
    setSelectedMerchantName(event.target.value.toString());
    await updateMerchantValuesInLocalStorage(event.target.value);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  const updateMerchantValuesInLocalStorage = (merchantId: string) => {
    const merchantByFilter = loginMerchantsList.filter(
      (item: any) => item.response?.stores?.store[0].id === merchantId
    );
    const merchantInfo = merchantByFilter[0]?.response?.stores?.store[0];
    const companyNameField = merchantInfo.custom_fields.field.find(
      (field: any) => {
        return field.name === "companyName";
      }
    );
    const merchantLogoField = merchantInfo.custom_fields.field.find(
      (field: any) => {
        return field.name === "merchant_image";
      }
    );

    dispatch(
      merchantActions.updateSelectedMerchantDetails({
        selectedMerchatDetails: {
          merchantName: merchantInfo.name,
          merchantId: merchantInfo.id,
          external_id: merchantInfo.external_id,
          storeCode: merchantInfo.code,
          companyName: companyNameField?.value,
          merchant_logo: merchantLogoField?.value,
        },
      })
    );
  };

  const name = isMerchantRole ? loginName : `${firstName} ${lastName}`;
  const getMercantInfo = (value: string) => {
    const info = merchantsList.filter((item: any) => item.value === value);
    return info[0];
  };

  return (
    <Grid
      container
      minWidth={"100%"}
      pl={4}
      pr={2}
      py={2}
      height={"100%"}
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{
        backgroundColor: theme?.color?.background,
      }}
      borderBottom={`${theme?.border?.xsmall} ${theme?.color?.dividerLight}`}
    >
      <Grid item>
        <CardMedia
          component="img"
          alt="Suntec Logo"
          image={SuntecNewLogo}
          sx={{ height: "50px" }}
        />
      </Grid>
      {isMerchantRole && (
        <Grid item display={"flex"} alignItems={"center"}>
          <FormControl sx={{ m: 1, minWidth: 320 }} size="small">
            <Select
              value={selectedMerchantName}
              onChange={handleClick}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              style={{ justifyContent: "center", alignItems: "center" }}
              renderValue={(value) => {
                return (
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <img
                      src={
                        getMercantInfo(value)?.merchant_logo
                          ? merchant_logo
                          : DefaultImage
                      }
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        marginRight: 10,
                      }}
                    />
                    {getMercantInfo(value)?.merchantName}
                  </Box>
                );
              }}
            >
              {merchantsList.map((item: any, index: number) => {
                return (
                  <MenuItem value={item.value} key={index}>
                    {item?.merchantName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
      )}

      <Grid
        item
        display={"flex"}
        alignItems={"center"}
        justifyContent={"flex-end"}
        width={
          constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN
            ? "15%"
            : "40%"
        }
      >
        {remainingTime !== null &&
          remainingTime <= 60 &&
          constant.domain !== process.env.REACT_APP_MERCHANT_DOMAIN && (
            <Grid item>
              <Box
                p={1}
                borderRadius={2}
                bgcolor="warning.main"
                display="flex"
                alignItems="center"
              >
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    color: "white",
                  }}
                >
                  {remainingTime > 0
                    ? `Session timing out in ${remainingTime} seconds`
                    : "Session Expired"}
                </Typography>
              </Box>
            </Grid>
          )}

        <Grid
          display={"flex"}
          alignItems={"center"}
          flex={4}
          justifyContent={"flex-end"}
        >
          <Typography
            mr={2}
            color={theme.color?.secondary}
            sx={{ fontFamily: theme.font?.fontFamily.primary }}
          >
            {name}
          </Typography>

          <Grid
            item
            display={"flex"}
            alignItems={"center"}
            width={"48px"}
            height={"48px"}
            mr={3}
          >
            <Button onClick={sendProfileStatus}>
              <Avatar
                src={
                  constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN
                    ? merchant_logo
                    : adminProfile.adminProfileImage
                }
                sx={{ height: "48px", width: "48px" }}
              ></Avatar>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Header;